import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import LoadingIcon from '../../../../LoadingIcon';
import SurveyService from '../../../../../Services/surveyService';
import ErrorMessage from '../../../../ErrorMessage';
import stringHelper from '../../../../../Helpers/stringHelper';

export default class SurveyMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('SurveyMultiChoice Onchange'),
    selected: [],
    fieldName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    SurveyService.GetSurveyList(-1)
      .then((result) => {
        const optValues = [];
        const selected = [];
        result
          .sort((a, b) => ((a.name ?? '') > (b.name ?? '') ? 1 : -1))
          .forEach((survey) => {
            if (survey.name) {
              const newValue = {
                label: survey.name + stringHelper.toBracket(survey.surveyId),
                value: survey.surveyId,
              };
              optValues.push(newValue);
              if (
                this.props.selected &&
                (this.props.selected.includes(survey.surveyId) ||
                  this.props.selected.includes(survey.surveyId.toString()))
              ) {
                selected.push(newValue);
              }
            }
          });
        this.setState({ itemList: optValues, loading: false, selected });
      })
      .catch((error) => {
        this.setState({ itemList: [], loading: false });
        ErrorMessage.SetErrorMessage('SVMC61', error);
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected });
    this.props.onChange(selected.map((i) => i.value));
  }

  renderList() {
    return (
      <MultiSelect
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='text-center arial w-100 text-center hover rounded arial m-1 p-1'>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
